import React, { useState, useEffect } from 'react';
import { styled } from "@mui/material/styles";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, TextField, Button, Typography, MenuItem, FormControl, Select, InputLabel, FormHelperText, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Grid from "@mui/material/Grid2";
import instance from "../../Utils/api";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import upload from '../../Admin/assets/images/upload-category.svg';
import Image from '../../Utils/getImage';



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));


const Addcatalogue = ({ openDialog, setOpenDialog, selectedCategory, setgetCategory, selectedsubCategory, setgetsubCategory, edit, setEdit, mode }) => {
    const title = mode === "category" ? "Add your category to the list" : "Add your Subcategory to the list";
    const [responseloading, setResponseLoading] = useState(false);
    const image = selectedCategory?.Bannerimage || "";
    const image1 = selectedsubCategory?.Bannerimage || "";
    const [category, setCategory] = useState([]);

    //category
    const fetchCategory = async () => {
        try {
            const response = await instance.get('/Catalogue/getCategorys')
            const formatteddata = response?.data?.data?.map((cate, index) => ({
                sno: index + 1,
                category: cate?.category,
                categoryId: cate?._id,
            }))

            setCategory(formatteddata);
        }
        catch (error) {
            console.log("error to fetch category:", error.message)
        }

    }

    useEffect(() => {
        fetchCategory();
    }, []);

    const handleClose = () => {
        setOpenDialog(false);
        setEdit(false);

        //category
        if (edit && selectedCategory) {
            // Set form data for edit
            setFormData({
                category: selectedCategory?.category || "",
                status: selectedCategory?.status === true ? "true" : "false",
                picture: null,
            });
            setErrors({
                category: "",
                status: "",
                picture: null,
            });
            setImagePreview('')
        } else {
            // Reset form data for add
            setFormData({
                category: "",
                status: "",
                picture: null,
            });
            setErrors({
                category: "",
                status: "",
                picture: null,
            });
            setImagePreview('')
        }

        //subcategory
        if (edit && selectedsubCategory) {
            // Set form data for edit
            setSubData({
                category: selectedsubCategory?.category || "",
                subCategory: selectedsubCategory?.subCategory || "",
                status: selectedsubCategory?.status === true ? "true" : "false",
                picture: null,
            });
            setErrorssub({
                category: "",
                subCategory: "",
                status: "",
                picture: null,
            });
            setsubImagePreview('')
        } else {
            // Reset form data for add
            setSubData({
                category: "",
                subCategory: "",
                status: "",
                picture: null,
            });
            // Reset form errors for add
            setErrorssub({
                subCategory: "",
                status: "",
                picture: null,
            });
            setsubImagePreview('')
        }
    };

    //category
    const [errors, setErrors] = useState({
        category: "",
        status: "",
        picture: "",
    });

    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        // status validation
        if (formData.status.trim() === "") {
            newErrors.status = "status is required";
            isValid = false;
        }

        // category validation
        if (formData.category.trim() === "") {
            newErrors.category = "category is required";
            isValid = false;
        }

        // picture validation
        if (!edit && !formData.picture) {
            newErrors.picture = "picture is required";
            isValid = false;
        }

        // Update the errors state
        setErrors(newErrors);

        return isValid;
    };

    const [formData, setFormData] = useState({
        category: "",
        status: "",
        picture: null,
    });
    const [imagePreview, setImagePreview] = useState(null);

    useEffect(() => {
        if (edit && selectedCategory) {
            setFormData({
                category: selectedCategory?.category || "",
                status: selectedCategory?.status === true ? "true" : "false",
                picture: null,
            });

            if (selectedCategory?.Bannerimage) {
                setImagePreview(image);
            } else {
                setImagePreview(null);
            }

        } else {
            setFormData({
                category: "",
                status: "",
                picture: null,
            });
            setImagePreview('')
        }
    }, [edit && selectedCategory]);

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        setFormData((prevFormData) => ({
            ...prevFormData,
            [name]: files ? files[0] : value,
        }));

        // If the field is a file input, create a preview URL
        if (files && files[0]) {
            setImagePreview(URL.createObjectURL(files[0])); // Set preview image
        }
        // Clear the error dynamically for the field
        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    const handlecategory = async () => {
        if (!validateForm()) {
            return;
        }
        setResponseLoading(true)
        try {
            const data = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                data.append(key, value);
            });
            const response = await instance.post('/Catalogue/addCategory', data)

            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetCategory(true)
                setResponseLoading(false)
            } else {
                toast.error(response.data.message)
                setResponseLoading(false)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
            setResponseLoading(false)
        }
    }

    const handleUpdateCatalogue = async () => {
        if (!validateForm()) {
            return;
        }
        try {
            const data = new FormData();
            Object.entries(formData).forEach(([key, value]) => {
                if (key !== "picture" || value !== null) {
                    data.append(key, value);
                }
            });

            const response = await instance.put(`/Catalogue/updateCategory?_id=${selectedCategory.categoryId}`, data)
            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetCategory(true)
            } else {
                toast.error(response.data.message)
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    //subcategory
    const [errorssub, setErrorssub] = useState({
        category: "",
        subCategory: "",
        status: "",
        picture: "",
    });

    const validateFormsub = () => {
        let isValid = true;
        const newErrors = {};

        // status validation
        if (subData.status.trim() === "") {
            newErrors.status = "status is required";
            isValid = false;
        }

        // subCategory validation
        if (!subData.category) {
            newErrors.category = "Category is required";
            isValid = false;
        }

        // subCategory validation
        if (subData.subCategory.trim() === "") {
            newErrors.subCategory = "subCategory is required";
            isValid = false;
        }

        // picture validation
        if (!edit && !subData.picture) {
            newErrors.picture = "picture is required";
            isValid = false;
        }

        // Update the errors state
        setErrorssub(newErrors);

        return isValid;
    };

    const [subData, setSubData] = useState({
        category: "",
        subCategory: "",
        status: "",
        picture: null,
    });
    const [subimagePreview, setsubImagePreview] = useState(null);

    useEffect(() => {
        if (edit && selectedsubCategory) {
            setSubData({
                category: selectedsubCategory?.category || "",
                subCategory: selectedsubCategory?.subCategory || "",
                status: selectedsubCategory?.status === true ? "true" : "false",
                picture: null,
            });

            if (selectedsubCategory?.Bannerimage) {
                setsubImagePreview(image1);
            } else {
                setsubImagePreview(null);
            }
        } else {
            setSubData({
                category: "",
                subCategory: "",
                status: "",
                picture: null,
            });
            setsubImagePreview('')
        }
    }, [edit && selectedsubCategory]);

    const handlesubInputChange = (e) => {
        const { name, value, files } = e.target;
        setSubData((prevFormData) => ({
            ...prevFormData,
            [name]: files ? files[0] : value,
        }));

        // If the field is a file input, create a preview URL
        if (files && files[0]) {
            setsubImagePreview(URL.createObjectURL(files[0]));
        }
        // Clear the error dynamically for the field
        setErrorssub((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    const handlesubcategory = async () => {
        if (!validateFormsub()) {
            return;
        }
        setResponseLoading(true)
        try {
            const data = new FormData();
            Object.entries(subData).forEach(([key, value]) => {
                data.append(key, value);
            });
            const response = await instance.post('/Catalogue/addSubCategory', data)

            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetsubCategory(true)
                setResponseLoading(false)
            } else {
                toast.error(response.data.message)
                setResponseLoading(false)
            }
        } catch (error) {
            toast.error(error?.response?.data?.message)
            setResponseLoading(false)
        }
    }

    const handleUpdatesubCatalogue = async () => {
        if (!validateFormsub()) {
            return;
        }
        try {
            const data = new FormData();
            Object.entries(subData).forEach(([key, value]) => {
                if (key !== "picture" || value !== null) {
                    data.append(key, value);
                }
            });

            const response = await instance.put(`/Catalogue/updateSubCategory?_id=${selectedsubCategory.subcategoryId}`, data)
            if (response.data.success === true) {
                toast.success(response.data.message)
                handleClose();
                setgetsubCategory(true)
            } else {
                toast.error(response.data.message)
            }
        }
        catch (error) {
            toast.error(error?.response?.data?.message);
        }
    }

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    {edit ? `Edit ${mode}` : `Add ${mode}`}
                    <Typography>{title}</Typography>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    {mode === 'category' ?
                        (
                            <section className='add-admin'>
                                <Grid container spacing={2}>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                        <div className='admin-textfiled'>
                                            {/* <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Select category</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label='Select category'
                                                    required
                                                    placeholder='Enter category name'
                                                    fullWidth
                                                    name="category"
                                                    value={formData.category}
                                                    onChange={(e) =>
                                                        handleInputChange({
                                                            target: {
                                                                name: "category",
                                                                value: e.target.value,
                                                            },
                                                        })
                                                    }
                                                    disabled={edit}
                                                >
                                                    <MenuItem value="Men">Men</MenuItem>
                                                    <MenuItem value="Women">Women</MenuItem>
                                                    <MenuItem value="Girl">Girl</MenuItem>
                                                    <MenuItem value="Boy">Boy</MenuItem>
                                                </Select>
                                                <FormHelperText error={!!errors.category}>
                                                    {errors.category}
                                                </FormHelperText>
                                            </FormControl> */}
                                            <TextField
                                                fullWidth
                                                label='Enter category'
                                                required
                                                placeholder='Enter category name'
                                                name="category"
                                                value={formData.category}
                                                onChange={(e) =>
                                                    handleInputChange({
                                                        target: {
                                                            name: "category",
                                                            value: e.target.value,
                                                        },
                                                    })
                                                }
                                            // disabled={edit}
                                            />
                                            <FormHelperText error={!!errors.category}>
                                                {errors.category}
                                            </FormHelperText>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                        <div className='admin-textfiled'>
                                            <FormControl fullWidth required>
                                                <InputLabel id="demo-simple-select-label">Select Status</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Select Status"
                                                    required
                                                    placeholder="Select Status"
                                                    fullWidth
                                                    name="status"
                                                    value={formData.status}
                                                    onChange={(e) =>
                                                        handleInputChange({
                                                            target: {
                                                                name: "status",
                                                                value: e.target.value,
                                                            },
                                                        })
                                                    }
                                                    disabled={edit}
                                                >
                                                    <MenuItem value="true">Active</MenuItem>
                                                    <MenuItem value="false">Inactive</MenuItem>
                                                </Select>
                                                <FormHelperText error={!!errors.status}>
                                                    {errors.status}
                                                </FormHelperText>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                        <div className='upload-image-preview'>
                                            <div className='file-upload-image'>
                                                <Typography variant='h5'>Category image upload *</Typography>
                                                <label htmlFor="file-upload" style={{ cursor: "pointer" }}>
                                                    <img src={upload} alt="upload" />
                                                </label>
                                                <input
                                                    id="file-upload"
                                                    type="file"
                                                    name="picture"
                                                    accept="image/*"
                                                    onChange={handleInputChange}
                                                    style={{ display: "none" }}
                                                />
                                                <FormHelperText error={!!errors.picture}>
                                                    {errors.picture}
                                                </FormHelperText>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                        {imagePreview && (
                                            <div className="categoryimage-preview" style={{ position: "relative", display: "inline-block" }}>
                                                <ul>
                                                    <li style={{ position: "relative", display: "inline-block" }}>
                                                        {typeof imagePreview === "string" && !imagePreview.startsWith("blob:") ? (
                                                            <Image
                                                                src={imagePreview}
                                                                alt="Category Banner"
                                                                width={150}
                                                                height={150}
                                                                className="rounded-md"
                                                            />
                                                        ) : (
                                                            <img
                                                                src={imagePreview}
                                                                alt="New Upload"
                                                                width={150}
                                                                height={150}
                                                                className="rounded-md"
                                                            />
                                                        )}
                                                        {/* Cancel / Remove button */}
                                                        <IconButton
                                                            onClick={() => setImagePreview(null)}
                                                            sx={{
                                                                position: "absolute",
                                                                top: -8,
                                                                right: -8,
                                                                backgroundColor: "white",
                                                                padding: "12px",
                                                                borderRadius: "50%",
                                                                boxShadow: "0 0 3px rgba(0,0,0,0.3)",
                                                                color: "#ff0000",
                                                                width: "20px",
                                                                height: "20px"
                                                            }}
                                                        >
                                                            <CloseIcon width="08px" height="08px" />
                                                        </IconButton>
                                                    </li>
                                                </ul>
                                            </div>
                                        )}
                                    </Grid>
                                </Grid>
                            </section>
                        ) : (
                            <section className='add-admin'>
                                <Grid container spacing={3}>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                        <div className="admin-textfiled">
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label" required>Select Category</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={subData.category}
                                                    onChange={handlesubInputChange}
                                                    label="Select Category"
                                                    name="category"
                                                    required
                                                    fullWidth
                                                >
                                                    {category.length > 0 ? (
                                                        category.map((cate) => (
                                                            <MenuItem key={cate.categoryId} value={cate.categoryId}>
                                                                {cate.category}
                                                            </MenuItem>
                                                        ))
                                                    ) : (
                                                        <MenuItem disabled>No Categories available</MenuItem>
                                                    )}
                                                </Select>
                                                <FormHelperText error={!!errorssub.category}>
                                                    {errorssub.category}
                                                </FormHelperText>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                        <div className='admin-textfiled'>
                                            {/* <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label">Select subCategory</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label='Select subCategory'
                                                    required
                                                    placeholder='Enter subCategory name'
                                                    fullWidth
                                                    name="subCategory"
                                                    value={subData.subCategory}
                                                    onChange={(e) =>
                                                        handlesubInputChange({
                                                            target: {
                                                                name: "subCategory",
                                                                value: e.target.value,
                                                            },
                                                        })
                                                    }
                                                    disabled={edit}
                                                >
                                                    <MenuItem value="Ethnic">Ethnic</MenuItem>
                                                    <MenuItem value="Western">Western</MenuItem>
                                                    <MenuItem value="Wedding">Wedding</MenuItem>
                                                    <MenuItem value="Event">Event</MenuItem>
                                                    <MenuItem value="Accessories">Accessories</MenuItem>
                                                    <MenuItem value="Bulk">Bulk</MenuItem>
                                                </Select>
                                                <FormHelperText error={!!errorssub.subCategory}>
                                                    {errorssub.subCategory}
                                                </FormHelperText>
                                            </FormControl> */}
                                            <TextField
                                                label='Enter subCategory'
                                                required
                                                placeholder='Enter subCategory name'
                                                fullWidth
                                                name="subCategory"
                                                value={subData.subCategory}
                                                onChange={(e) =>
                                                    handlesubInputChange({
                                                        target: {
                                                            name: "subCategory",
                                                            value: e.target.value,
                                                        },
                                                    })
                                                }
                                            // disabled={edit}
                                            />
                                            <FormHelperText error={!!errorssub.subCategory}>
                                                {errorssub.subCategory}
                                            </FormHelperText>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6 }}>
                                        <div className='admin-textfiled'>
                                            <FormControl fullWidth>
                                                <InputLabel id="demo-simple-select-label" required>Select Status</InputLabel>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    label="Select Status"
                                                    required
                                                    placeholder="Select Status"
                                                    fullWidth
                                                    name="status"
                                                    value={subData.status}
                                                    onChange={(e) =>
                                                        handlesubInputChange({
                                                            target: {
                                                                name: "status",
                                                                value: e.target.value,
                                                            },
                                                        })
                                                    }
                                                    disabled={edit}
                                                >
                                                    <MenuItem value="true">Active</MenuItem>
                                                    <MenuItem value="false">Inactive</MenuItem>
                                                </Select>
                                                <FormHelperText error={!!errorssub.status}>
                                                    {errorssub.status}
                                                </FormHelperText>
                                            </FormControl>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                        <div className='upload-image-preview'>
                                            <div className='file-upload-image'>
                                                <Typography variant='h5'>Sub Category image upload *</Typography>
                                                <label htmlFor="file-upload" style={{ cursor: "pointer" }}>
                                                    <img src={upload} alt="upload" />
                                                </label>
                                                <input
                                                    id="file-upload"
                                                    type="file"
                                                    accept="image/*"
                                                    name="picture"
                                                    onChange={handlesubInputChange}
                                                    style={{ display: "none" }} // Hide the input
                                                />
                                                <FormHelperText error={!!errorssub.picture}>
                                                    {errorssub.picture}
                                                </FormHelperText>
                                            </div>
                                        </div>
                                    </Grid>
                                    <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
                                        {subimagePreview && (
                                            <div className="categoryimage-preview">
                                                <ul>
                                                    <li style={{ position: "relative", display: "inline-block" }}>
                                                        {typeof subimagePreview === "string" && !subimagePreview.startsWith("blob:") ? (
                                                            <Image
                                                                src={subimagePreview}
                                                                alt="Category Banner"
                                                                width={150}
                                                                height={150}
                                                                className="rounded-md"
                                                            />
                                                        ) : (
                                                            <img
                                                                src={subimagePreview}
                                                                alt="New Upload"
                                                                width={150}
                                                                height={150}
                                                                className="rounded-md"
                                                            />
                                                        )}
                                                        {/* Cancel / Remove button */}
                                                        <IconButton
                                                            onClick={() => setsubImagePreview(null)} // Remove image on click
                                                            sx={{
                                                                position: "absolute",
                                                                top: -8,
                                                                right: -8,
                                                                backgroundColor: "white",
                                                                padding: "12px",
                                                                borderRadius: "50%",
                                                                boxShadow: "0 0 3px rgba(0,0,0,0.3)",
                                                                color: "#ff0000",
                                                                width: "20px",
                                                                height: "20px"
                                                            }}
                                                        >
                                                            <CloseIcon width="08px" height="08px" />
                                                        </IconButton>
                                                    </li>
                                                </ul>
                                            </div>
                                        )}
                                    </Grid>
                                </Grid>
                            </section>
                        )
                    }
                </DialogContent>
                <DialogActions>
                    {mode === "category" ? (
                        <>
                            <Button
                                className="cancel-btn"
                                onClick={handleClose}>
                                Cancel
                            </Button>
                            <Button className='add-btn' onClick={edit ? handleUpdateCatalogue : handlecategory}>
                                {responseloading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : edit ? 'Update' : 'Add'}
                            </Button>
                        </>
                    ) : (
                        <>
                            <Button
                                className="cancel-btn"
                                onClick={handleClose}>
                                Cancel
                            </Button>
                            <Button className='add-btn' onClick={edit ? handleUpdatesubCatalogue : handlesubcategory}>
                                {responseloading ? <CircularProgress size={20} sx={{ color: 'white' }} /> : edit ? 'Update' : 'Add'}
                            </Button>
                        </>
                    )
                    }
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default Addcatalogue;